import React from 'react'
import { Modal } from 'antd'
import PropTypes from 'prop-types'
import './index.scss'

const BasicService = (props) => {
  const { visible, onClose, params } = props
  const { servicesDesc, claimLimit } = params

  const getServiceExt = (service, index) => {
    if (index === 0 && claimLimit > 0 && claimLimit <= 200) {
      return (
        <>
          <p className="item-content">{service?.desc}</p>
          <span className="payment">本车最高赔付上限{claimLimit || 0}万</span>
          <p className="payment-tips">
            注：定期保养需要更换的易损零部件不属于质保范围。具体质保内容及实际售后服务提供方以签署的电子版《车辆售后服务协议》中约定的为准
          </p>
        </>
      )
    }
    if (service.text === '焕新清洁') {
      return (
        <>
          <div className="clean-line">
            本车已通过人人车专项全车焕新清洁整备服务。
          </div>
          <div className="clean-line">
            经人人车严选商城成交的严选车辆，人人车在收车前，先要进行专业团队249项深度检测，精选出放心车源后，对车辆进行全面安全性能体检和深度清洁和美容。让您买车用车更放心，花更少的钱，买更好的车。
          </div>
          <div className="clean-line info-title">
            全车焕新清洁整备服务内容
          </div>
          <div className="clean-line">
            <p>
              1.深度精致护理洗车、内饰各部件深度清洁、中控台清洁上光、真皮座椅内饰皮革护理、地毯脚垫清洁处理、360强力吸尘、内饰空间臭氧消毒除菌除味。
            </p>
            <p>
              2.内饰清洁完成后对车辆进行深度精致护理洗车，同时臭氧消毒除菌除异味。全程使用环保清洁产品，整备完成后全车焕然一新，整洁无暇。
            </p>
          </div>
          <div className="clean-line info-title">整备影响了什么</div>
          <div className="clean-line">
            人人车保证不影响真实车况，整备仅限于对车辆的精洗和美容，让您获得准新车一般的感官体验。
          </div>
        </>
      )
    }
    return (
      <>
        <p className="item-content">{service?.desc}</p>
      </>
    )
  }
  return (
    <Modal
      centered
      visible={visible}
      footer={null}
      bodyStyle={{ padding: '40px 50px' }}
      width={680}
      onCancel={onClose}
    >
      <div className="r-services">
        <h2 className="title">人人车服务介绍</h2>
        {servicesDesc
          && servicesDesc.map((service, index) => (
            <div className="service" key={service?.text}>
              <h3 className="item-title">
                <i className="iconfont icon-right_blue" />
                {service.text}
              </h3>
              {getServiceExt(service, index)}
            </div>
          ))}
      </div>
    </Modal>
  )
}

export default BasicService

BasicService.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  params: PropTypes.object
}

BasicService.defaultProps = {
  visible: false,
  onClose: null,
  params: {
    servicesDesc: [],
    claimLimit: ''
  }
}
